import React, { useState } from 'react'
import { Badge, Button, Icon, Thumbnail, Collapsible } from '@shopify/polaris';
import { XIcon } from '@shopify/polaris-icons';
import { useSelector } from 'react-redux';
import './style.css'
import cancel from "../../images/cancel.svg";
import placeholder from "../../images/placeholder.svg";

const ItemList = props => {

    const { ConfigReducer } = useSelector(state => state)
    const [open, setOpen] = useState({});

    const handleToggle = id => setOpen({ ...open, [id]: !open[id] });
    return (
        <div className="listWrapper" style={{ overflowY: props.items.length >= 3 ? 'scroll' : 'hidden' }}>
            {
                props.items.map((item, p) => {
                    const { id, title } = item;

                    const productUrl = `https://admin.shopify.com/store/${ConfigReducer.shopName}/products/${id.replace('gid://shopify/Product/', '')}`

                    return <div className='parent'>
                        <div className="item" style={{ borderTop: p === 0 ? 'none' : '0.25px solid #E0E3E5;' }}>
                            <div className="count">{p + 1}.</div>
                            <div className={item.images[0] ? "thumbnail" : "thumbnail placeholder"}
                                style={{ alignItems: item.variants.length ? 'flex-start' : 'center' }}
                            >
                                <Thumbnail
                                    source={item.images[0] ? item.images[0].originalSrc : placeholder}
                                    size="small"
                                    alt={title}
                                />
                            </div>
                            <div className="title">
                                <a href={productUrl} target="_blank" rel="noopener noreferrer">{title}</a>
                            </div >
                            <div className="badge"><Badge status={item.status.toLowerCase() === 'active' ? 'success' : 'info'}>{item.status.toLowerCase() === 'active' ? 'Active' : 'Draft'}</Badge></div>

                            <div className="remove"
                                style={{ alignItems: item.variants.length ? 'flex-start' : 'center' }}
                            >
                                {
                                    props.removeItem ? <Button variant="plain" loading={props.loading.p[p]} disabled={props.loading.p[p]} onClick={() => props.removeItem(p)}><Icon source={XIcon} tone="critical" /></Button> : null
                                }
                            </div>
                        </div>
                        {
                            !item.hasOnlyDefaultVariant ? <div className='variants'>
                                <Collapsible
                                    open={open[item.id]}
                                    id="basic-collapsible"
                                    transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}
                                    expandOnPrint
                                >
                                    <span className="variantList">
                                        {
                                            item.variants.map((variant, v) => {
                                                const variantUrl = `${productUrl}/variants/${variant.id.replace('gid://shopify/ProductVariant/', '')}`
                                                return <span style={{ display: 'inline-block', margin: '3px' }}>
                                                    <Badge size="small" status='base'><a href={variantUrl} className="variantTitle" target="_blank" rel="noopener noreferrer">{variant.title}</a>
                                                        {
                                                            props.removeItem ? <Button variant="plain" loading={props.loading.v[v]} disabled={props.loading.v[v]} size="slim" onClick={() => props.removeItem(p, v)}>
                                                                {/* <Icon source={XIcon} tone="critical" /> */}
                                                                <img src={cancel} width="10px" alt="cancel" />
                                                            </Button> : null
                                                        }
                                                    </Badge>
                                                </span>
                                            })
                                        }
                                    </span>
                                </Collapsible>
                                <span className="toggle">
                                    <Button
                                        variant="plain"
                                        onClick={() => handleToggle(item.id)}
                                        ariaExpanded={open}
                                        ariaControls="basic-collapsible"
                                    >
                                        {open[item.id] ? 'Hide variants' : 'Show variants'}
                                    </Button>
                                </span>
                            </div> : null
                        }
                    </div>
                })
            }
        </div >
    )
}

export default ItemList